<template>
  <section class="joinMyFes" v-show="events.length > 0">
    <div class="u-containar">
      <HeadingLv2 :text="heading" icon="calendar" />

      <div class="swiper-container-wrapper">
        <div class="swiper-container joinMyFesSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="event in events" :key="event">
              <EventCard
                :title="event.title"
                :eventTypes="event.eventTypes"
                :thumbnail="event.thumbnailUrl"
                :date="event.displayTerm"
                :place="event.placeName"
                :tags="event.tags"
                :link="event.link"
                :category="event.categoryName"
                rectangle
                class="swiper-slide__card"
              />
            </div>
          </div>
        </div>
        <div
          class="swiper-button-next joinMyFesSwiperNext"
          :class="visibleClass(navigation)"
        />
        <div
          class="swiper-button-prev joinMyFesSwiperPrev"
          :class="visibleClass(navigation)"
        />
      </div>

      <Button
        href="/events/list"
        label="イベントトップへ"
        :handleClick="
          () => {
            $router.push('/events/list')
          }
        "
        primary
      />
      <ArchiveBanner />
    </div>
  </section>
</template>

<script lang="ts">
import { computed, nextTick, onMounted, ref, watch, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Swiper, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'
import ArchiveBanner from '@/components/block/ArchiveBanner.vue'
import EventCard from '@/components/block/EventCard.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'JoinMyFes',

  components: {
    ArchiveBanner,
    EventCard,
    HeadingLv2,
    Button
  },

  props: {
    heading: {
      type: String,
      default: 'イベントに参加する'
    },
    navigation: {
      type: Array,
      default: () => []
    }
  },

  setup() {
    const store = useStore()
    const events = computed(() => store.getters['home/getEvents'])
    const visibleClass = (arr: any) => ({
      hiddenPc: !arr.includes('pc'),
      hiddenSp: !arr.includes('sp')
    })

    const mySwiper = ref<any>(null)
    watch(
      () => events.value,
      () => {
        nextTick(() => mySwiper.value.update())
      }
    )

    onMounted(() => {
      Swiper.use([Navigation])
      mySwiper.value = new Swiper('.joinMyFesSwiper', {
        breakpoints: {
          900: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0
          }
        },
        slidesPerView: 1.4,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        navigation: {
          nextEl: '.joinMyFesSwiperNext',
          prevEl: '.joinMyFesSwiperPrev'
        }
      })
    })

    return {
      visibleClass,
      events
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.joinMyFes {
  padding-top: 18px;
  padding-bottom: 40px;
  background: #ffe869;
  background: -moz-linear-gradient(left, #ffe869 0%, #caf58f 100%);
  background: -webkit-linear-gradient(left, #ffe869 0%, #caf58f 100%);
  background: linear-gradient(to right, #ffe869 0%, #caf58f 100%);
  overflow: hidden;

  @include mixins.media() {
    padding-top: 40px;
    padding-bottom: 48px;
  }

  .headingLv2 {
    margin-bottom: 20px;
  }

  .button {
    margin-top: 25px;
    margin-bottom: 25px;
  }
}

.swiper-container-wrapper {
  margin-left: -16px;
  margin-right: -16px;

  @include mixins.media() {
    margin-left: 0px;
    margin-right: 0px;
  }
}

.swiper-slide {
  height: auto;
}
.swiper-slide__card {
  height: 100%;
}

.swiper-button-next,
.swiper-button-prev {
  background-color: #fff;
  width: 50px;
  height: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 6px;
  position: absolute;
  transition: 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &::after {
    transform: scale(0.4);
  }
}
.swiper-button-next {
  top: 50%;
  right: -90px;
  transform: translate(-50%, 0);
}
.swiper-button-prev {
  top: 50%;
  left: -90px;
  transform: translate(50%, 0);
}
.swiper-container-wrapper {
  position: relative;
}
::v-deep .swiper-button-next,
.swiper-button-prev {
  color: var.$color-main !important;
}
</style>
